/**
 * Created by linjianxi on 2016/11/10.
 */
export const initPay = (state) => {
  return state
}



// WEBPACK FOOTER //
// ./src/vuex/modules/recharge/getter.js